import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/business-partner/_list/_placeholders/operation-activity')({
  component: RouteComponent
});
function RouteComponent() {
  return <ComingSoonCover disableBlurBackdrop={true} />;
}